module.exports = __webpack_public_path__ + "94580bb99ea70b3dd78dcb897e8d1409.jpg";